import { render, staticRenderFns } from "./MyInvoicePage.vue?vue&type=template&id=ca1cfa1a&scoped=true&"
import script from "./MyInvoicePage.vue?vue&type=script&lang=ts&"
export * from "./MyInvoicePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1cfa1a",
  null
  
)

export default component.exports